var _path, _g, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_103_10397",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4C15.7712 4 17.6569 4 18.8284 5.17157C20 6.34315 20 8.22876 20 12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12Z",
    fill: "#273B4A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_103_10397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.14212 12.5247L6.00634 12.6605L6.00634 12.6605C5.2732 13.3936 4.90663 13.7602 4.6512 14.1892C4.41784 14.5811 4.25324 15.0101 4.16451 15.4575C4.06739 15.9472 4.09464 16.4649 4.14913 17.5003L4.44444 23.1113H20V18.8955C20 17.8016 20 17.2546 19.8635 16.7456C19.7548 16.3404 19.5831 15.9548 19.3546 15.603C19.0676 15.161 18.661 14.7951 17.8479 14.0633L17.6572 13.8916C17.0099 13.309 16.6862 13.0177 16.3341 12.8849C15.8451 12.7004 15.3033 12.7146 14.8246 12.9246C14.48 13.0758 14.1721 13.3837 13.5563 13.9995C13.1001 14.4556 12.8721 14.6836 12.6398 14.7574C12.3169 14.8598 11.9642 14.7919 11.7025 14.5769C11.5142 14.4221 11.3847 14.1201 11.1258 13.516C10.5683 12.2151 10.2896 11.5647 9.87069 11.2456C9.37316 10.8666 8.72697 10.7421 8.12427 10.9093C7.61684 11.05 7.12527 11.5416 6.14212 12.5247Z",
    stroke: "white",
    strokeWidth: 2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12C4 8.22876 4 6.34315 5.17157 5.17157C6.34315 4 8.22876 4 12 4V4C15.7712 4 17.6569 4 18.8284 5.17157C20 6.34315 20 8.22876 20 12V12C20 15.7712 20 17.6569 18.8284 18.8284C17.6569 20 15.7712 20 12 20V20C8.22876 20 6.34315 20 5.17157 18.8284C4 17.6569 4 15.7712 4 12V12Z",
    stroke: "white",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 8.5,
    r: 1.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageWhite);
export default __webpack_public_path__ + "static/media/image_white.09bc62b29d7930876a37f79bf0447837.svg";
export { ForwardRef as ReactComponent };